<template>
    <div>
        Dieses Fenster nicht schließen!
    </div>
</template>

<script>
    import ProxyReceiverJS from './ProxyReceiverJS.js';
    //import ProxyReceiverJS from document.location.href.replace(/\/#.*$/, '').replace(/^http:\/\//i, 'https://') + '/' + 'js/ProxyReceiverJS.js';

    export default {
        name: 'ProxyReceiver',
        props: {
            url: { required: true, type: String },
            proxy: { required: true, type: String },
            receiver: { required: true, type: String },
        },
        mounted: function () {
            var proxyReceiver = new ProxyReceiverJS(this.url, this.proxy, this.receiver);
            proxyReceiver.startReceiving();
        }
    }
</script>

<style scoped>
</style>